import { TableColumn } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';
export const getTableColumns = ({ hideColumnsForDeleteMode }: { hideColumnsForDeleteMode?: boolean }) => {
  const { isMobile } = useScreen();
  const columnsDesktop: TableColumn[] = [
    { name: 'id', label: '', align: 'left', sticky: true, colWidth: '80px' },
    { name: 'payment_method_type', label: 'PAYMENT_METHOD_TYPE', align: 'left', colWidth: '180px' },
    { name: 'provider_id', label: 'PROVIDER_ID_IN_PROVIDER_CONTEXT', align: 'left', colWidth: '180px' },
    // { name: 'agent_id', label: 'AGENT_ID_IN_PROVIDER_CONTEXT', align: 'left', colWidth: '180px' },
    { name: 'created_at', label: 'CREATED_AT_FOR_TABLE', align: 'left', colWidth: '140px' },
    { name: 'more_actions', label: '', align: 'left', colWidth: '24px' },
  ];
  const columnsMobile: TableColumn[] = [
    { name: 'provider_id', label: '', align: 'left', sticky: true, colWidth: '80px' },
    { name: 'payment_method_type', label: 'PAYMENT_METHOD_TYPE', align: 'left', colWidth: '180px' },
    { name: 'id', label: 'PROVIDER_ID_IN_PROVIDER_CONTEXT', align: 'left', colWidth: '180px' },
    { name: 'more_actions', label: '', align: 'left', colWidth: '24px' },
  ];
  const columnsToHideForDeleteMode = ['created_at', 'more_actions'];
  const hideMoreActionsColumnIfNeeded = (columns: TableColumn[], hideColumnsForDeleteMode?: boolean) => {
    if (hideColumnsForDeleteMode) {
      return columns.filter((column) => !columnsToHideForDeleteMode.includes(column.name));
    }
    return columns;
  };
  return !isMobile
    ? hideMoreActionsColumnIfNeeded(columnsDesktop, hideColumnsForDeleteMode)
    : hideMoreActionsColumnIfNeeded(columnsMobile, hideColumnsForDeleteMode);
};
